export default __webpack_public_path__ + "static/media/error-close.64bcdf2e.svg";